var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnife(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Knife",
    clipPath: "url(#clip0_23_1729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.589649 13.2617C0.0616019 12.7742 0.0615749 11.9839 0.589649 11.4965L4.08578 8.2693L5.99803 10.0344L2.50188 13.2616C1.97383 13.7491 1.1177 13.7491 0.589649 13.2617Z",
    fill: "url(#paint0_linear_23_1729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5823 0.955841C12.5062 0.885595 12.4031 0.846153 12.2955 0.846153C12.1879 0.846153 12.0847 0.885595 12.0087 0.955841L9.36386 3.3972L4.08569 8.26931L6.66724 10.6523C6.82566 10.7985 7.08249 10.7985 7.24091 10.6523L12.8002 5.49636C14.0099 4.16304 13.9264 2.1965 12.5823 0.955841Z",
    fill: "url(#paint1_linear_23_1729)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_1729",
    x1: 0.589649,
    y1: 13.2616,
    x2: 4.68628,
    y2: 8.82361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_1729",
    x1: 5.51988,
    y1: 9.59317,
    x2: 13.0739,
    y2: 1.40963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8462,
    height: 12.7811,
    fill: "white",
    transform: "translate(0 0.846153)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnife);
export default __webpack_public_path__ + "static/media/Knife.505a26dcede4dc868dfd0a7c5aadff55.svg";
export { ForwardRef as ReactComponent };